
export const API_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
// export const API_URL = "http://localhost:8077";
// export const API_URL = "https://kipp.murphycc.com";
export const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiZGVtbyIsImlhdCI6MTc2MDk4NzY5NX0.7XHP_uNwimnBrOTKfd8BUiGVErio2pvcMRgyqtOL5Qc";

